import { styled } from '@mui/material/styles';

import AtomFlex from '../../../atoms/AtomFlex';
import { styleConfigs } from '../../../resources/styleConfigs';
import BoxWrapper from '../../../wrappers/BoxWrapper';
import IconComponent from '../../IconComponent/IconComponent';

export const EmptyStateWrapperStyled = styled(AtomFlex)(({ gaptitlesbutton }: { gaptitlesbutton?: number }) => ({
  width: styleConfigs.dimensions.percent100,
  height: styleConfigs.dimensions.percent100,
  alignItems: 'center',
  placeContent: 'center',
  textAlign: 'center',
  gap: gaptitlesbutton,
}));

export const StackEmptyStateStyled = styled(AtomFlex)(
  ({
    margintopstackicon,
    marginbottomstackicon,
    directionicontitle,
    gapicontitle,
  }: {
    margintopstackicon?: number;
    marginbottomstackicon?: number;
    directionicontitle?: string;
    gapicontitle?: number | string;
  }) => ({
    flexFlow: `${directionicontitle} ${'wrap'} !important`,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: margintopstackicon,
    marginBottom: marginbottomstackicon,
    gap: gapicontitle,
  }),
);

export const EmptyStateIconStyled = styled(IconComponent)(
  ({
    widthicon,
    heighticon,
    iconlinewidth,
    iconcolor,
  }: {
    widthicon?: number | string;
    heighticon?: number | string;
    iconlinewidth?: number;
    iconcolor?: string;
  }) => ({
    width: `${widthicon}px !important`,
    height: `${heighticon}px !important`,
    fontSize: `${iconlinewidth}px !important`,
    color: iconcolor,
  }),
);

export const BoxEmptyStateButtonStyled = styled(BoxWrapper)(({ margintopbutton }: { margintopbutton?: number }) => ({
  marginTop: margintopbutton,
}));
